const $$splitComponentImporter = () => import('/app/src/routes/{-$locale}/offers/$id/builds.tsx?tsr-split=component');
import { lazyRouteComponent } from '@tanstack/react-router';
import { generateOfferMeta } from "@/lib/generate-offer-meta";
import { httpClient } from "@/lib/http-client";
import { offerOnlyQueryOptions } from "@/queries/offer-gql";
import { dehydrate, queryOptions } from "@tanstack/react-query";
import { createFileRoute } from "@tanstack/react-router";
import i18n from "@/lib/i18n";
const getOfferBuilds = (id: string) => queryOptions({
  queryKey: ["offer-builds", {
    id
  }],
  queryFn: () => httpClient.get<Build[]>(`/offers/${id}/builds`).catch(() => [])
});
type LoaderData = {
  dehydratedState: DehydratedState;
  id: string;
  offer: SingleOffer | null;
};
export const Route = createFileRoute("/{-$locale}/offers/$id/builds")({
  component: lazyRouteComponent($$splitComponentImporter, 'component'),
  loader: async ({
    params,
    context
  }) => {
    const {
      queryClient,
      locale
    } = context;
    const offer = await queryClient.ensureQueryData(offerOnlyQueryOptions(params.id, locale));
    await queryClient.prefetchQuery(getOfferBuilds(params.id));
    return {
      id: params.id,
      dehydratedState: dehydrate(queryClient),
      offer
    };
  },
  head: ctx => {
    if (!ctx.loaderData) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    const {
      offer
    } = ctx.loaderData;
    if (!offer) {
      return {
        meta: [{
          title: i18n.t("offerDetail.common.offerNotFound"),
          description: i18n.t("offerDetail.common.offerNotFound")
        }]
      };
    }
    return {
      meta: generateOfferMeta(offer, i18n.t("offerDetail.builds.title"))
    };
  }
});